import { Component } from '@angular/core';
import { DiscussionPageBaseComponent } from '../../shared/discussion-page-base/discussion-page-base.component';

@Component({
  selector: 'app-discussion-feedback',
  standalone: true,
  imports: [DiscussionPageBaseComponent],
  template: `
    <app-discussion-page-base
      pageTitle="Feedback"
      pageDescription="Share your feedback, suggestions, and ideas to help improve MahaAgX. Your input helps us build a better platform for everyone."
      activeTab="feedback"
      categoryType="PRODUCT_FEEDBACK"
    ></app-discussion-page-base>
  `,
})
export class DiscussionFeedbackComponent {}
